var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 28,
    viewBox: "0 0 15 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.879347 14.9128H3.9486V27.5484C3.9486 27.7979 4.15074 28 4.40021 28H9.60424C9.85371 28 10.0559 27.7979 10.0559 27.5484V14.9723H13.5842C13.8136 14.9723 14.0066 14.8002 14.0328 14.5723L14.5687 9.92049C14.5835 9.7925 14.5429 9.66434 14.4573 9.56832C14.3716 9.47222 14.2489 9.41721 14.1202 9.41721H10.056V6.50124C10.056 5.62222 10.5293 5.17648 11.4629 5.17648C11.5959 5.17648 14.1202 5.17648 14.1202 5.17648C14.3697 5.17648 14.5718 4.97425 14.5718 4.72486V0.454955C14.5718 0.205484 14.3697 0.00334194 14.1202 0.00334194H10.4581C10.4322 0.00207742 10.3749 0 10.2903 0C9.65491 0 7.44625 0.124735 5.70158 1.72977C3.76849 3.5084 4.0372 5.63803 4.10142 6.00727V9.41712H0.879347C0.629876 9.41712 0.427734 9.61926 0.427734 9.86874V14.4611C0.427734 14.7106 0.629876 14.9128 0.879347 14.9128Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.aeb3db06668bad890f5e31e409308c17.svg";
export { ForwardRef as ReactComponent };